// Header Dropdown Menu on hover

// Header Links On Hover
document.addEventListener('DOMContentLoaded', function () {
  let items = document.querySelectorAll(".header__inline-menu details");

  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", "true");
      item.querySelector(".mega-menu__content").style.display = 'block';
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      item.querySelector(".mega-menu__content").style.display = 'none';
    });
  });
});

$(document).ready(function () {
  $('product-info').css('opacity', '1');
  $('section.category-slider').css('opacity', '1');

  // Check if the .globo-app-extension exists
  if ($('.globo-app-extension').length) {
    // Append the .globo-app-extension element to .contact
    $('.globo-app-extension').appendTo('.contact form');
  }

  
});


document.addEventListener('DOMContentLoaded', function () {
  $('.mega-menu__content').hide();


  var checkExist = setInterval(function () {
    var sizeOption = $('.swatches-type-collections .swatch-view-item'); // Select all size option elements
    if (sizeOption.length) {
      // Remove any previously attached click handlers to avoid duplicates
      sizeOption.off('click').on('click', function () {
        var size = $(this).attr('orig-value');
        console.log('Selected size:', size);

        var parentIE = $(this).closest('.grid__item');
        console.log('parentIE', parentIE);

        var linkElement = parentIE.find('a.full-unstyled-link');
        if (linkElement.length) {
          // MutationObserver to detect href changes
          var observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
                var updatedHref = mutation.target.getAttribute('href');
                if (updatedHref) {
                  console.log('Detected href change, redirecting to:', updatedHref);
                  window.location.href = updatedHref; // Redirect to the updated URL
                }
              }
            });
          });

          // Start observing the link element for attribute changes
          observer.observe(linkElement[0], { attributes: true });

          // Attach or reattach a click event listener to handle dynamic URL redirection
          linkElement.off('click').on('click', function (event) {
            event.preventDefault(); // Prevent the default action of the anchor tag
            var currentHref = $(this).attr('href'); // Get the current value of the 'href' attribute
            if (currentHref) {
              console.log('Redirecting to:', currentHref);
              window.location.href = currentHref; // Redirect to the URL specified in the 'href' attribute
            } else {
              console.log('The href attribute is missing or empty in the linkElement');
            }
          });
        } else {
          console.log('Element with class "full-unstyled-link" not found within parentIE');
        }
      });

      clearInterval(checkExist);
    }
  }, 500);





  $('.hero-banner-wrap').slick({
    draggable: true,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 500,
    infinite: true,
    cssEase: 'ease-in-out',
    touchThreshold: 100,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.ct-wrap').slick({
    dots: false,
    arrow: false,
    infinite: false,
    speed: 300,
    slidesToShow: 7.6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      }
    ],
  });

  $('.trending-grid').slick({
    dots: true,
    arrow: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    draggable: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }
    ],
  });



  $(function () {
    $('li a[href*=\\#]:not([href=\\#])').on('click', function () {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.substr(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 90
        }, 500);
        return false;
      }
    });
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $('body').addClass('showSticky');
    } else {
      $('body').removeClass('showSticky');
    }
  });



  // Handle hover event on the summary
  $('summary').hover(
    function () {
      // Mouse enters the summary
      var menuContent = $(this).next('.mega-menu__content');

      // Stop ongoing animations and hide other menus
      $('.mega-menu__content').not(menuContent).stop(true, true).slideUp(400);

      // Ensure the current menu content is visible
      menuContent.stop(true, true).slideDown(400);

      // Update aria-expanded attribute
      $(this).attr('aria-expanded', 'true');
    },
    function () {
      // Mouse leaves the summary
      var menuContent = $(this).next('.mega-menu__content');

      // Set a delay before hiding
      setTimeout(function () {
        if (!menuContent.is(':hover') && !$(this).is(':hover')) {
          menuContent.stop(true, true).slideUp(400);
          $(this).attr('aria-expanded', 'false');
        }
      }.bind(this), 200); // Delay before hiding
    }
  );


  // Handle hover event on the menu content
  $('.mega-menu__content').hover(
    function () {
      // Mouse enters the menu content
      $(this).stop(true, true).slideDown(400);
      $(this).prev('summary').attr('aria-expanded', 'true');
    },
    function () {
      // Mouse leaves the menu content
      var summary = $(this).prev('summary');

      // Set a delay before hiding
      setTimeout(function () {
        if (!summary.is(':hover') && !$(this).is(':hover')) {
          $(this).stop(true, true).slideUp(400);
          summary.attr('aria-expanded', 'false');
        }
      }.bind(this), 400); // Delay before hiding
    }
  );
});


$(document).ready(function () {
  $('.menu-drawer .menu-drawer__header svg').click(function () {
    console.log('Click');

    // Select the menu drawer container
    var $menuDrawer = $(this).closest('#Details-menu-drawer-container');

    // Toggle the class 'menu-opening' and 'aria-expanded' attribute
    var $headerIcon = $menuDrawer.find('.header__icon');

    // Check current state and toggle
    var isExpanded = $headerIcon.attr('aria-expanded') === 'true';

    // Toggle class and attribute based on current state
    $menuDrawer.toggleClass('menu-opening', !isExpanded);
    $headerIcon.attr('aria-expanded', !isExpanded);

    $('body').removeClass('overflow-hidden-tablet');

    // Remove 'open' attribute if needed
    $menuDrawer.removeAttr('open');
  });



  function handleResize() {
    if ($(window).width() > 749) {
      $('.footer-block--menu .footer-block__details-content').show();
      $('.footer-block--menu .footer-block__heading').removeClass('active');
    } else {
      $('.footer-block--menu .footer-block__details-content').hide();

      var $firstHeading = $('.footer-block--menu .footer-block__heading').first();
      var $firstDetailsContent = $firstHeading.siblings('.footer-block__details-content');

      $firstHeading.addClass('active');
      $firstDetailsContent.show();
    }
  }

  $('.footer-block--menu .footer-block__heading').on('click', function () {
    if ($(window).width() <= 749) {
      var $detailsContent = $(this).siblings('.footer-block__details-content');

      // Remove active class from all headings and slide up all contents
      $('.footer-block--menu .footer-block__heading').removeClass('active');
      $('.footer-block--menu .footer-block__details-content').slideUp(300);

      // Add active class to the clicked heading and slide down its content if it was not open
      if (!$detailsContent.is(':visible')) {
        $(this).addClass('active');
        $detailsContent.slideDown(300);
      }
    }
  });

  // Handle resize event
  $(window).on('resize', handleResize);

  // Initial check on page load
  handleResize();

  // Hero Slider





  var action = 'click';
  var speed = '500';

  // Open the first FAQ by default
  $('li.q').first().addClass('active').next().slideDown(speed);

  $('li.q').on(action, function () {
    // Check if the clicked question is already active
    if ($(this).hasClass('active')) {
      // If it is active, remove the active class and hide the answer
      $(this).removeClass('active').next().slideUp(speed);
    } else {
      // Remove active class from all questions and hide all answers
      $('li.q').removeClass('active').next('li.a').slideUp(speed);

      // Add active class to the clicked question and show the answer
      $(this).addClass('active').next().slideDown(speed);
    }
  });

  function addClassToParent() {
    // Check if .instagrid-feed-container exists
    if ($('#instagrid-feed-container').length) {
      // Find the parent .shopify-section and add the news-insta class
      $('#instagrid-feed-container').closest('.shopify-section').addClass('news-insta');

      // If the class is successfully added, stop the interval
      if ($('.shopify-section').hasClass('news-insta')) {
        clearTimeout(checkClassInterval); // Stop the interval
      }
    }
  }

  // Set an interval to repeatedly check and add the class
  var checkClassInterval = setInterval(addClassToParent, 100); // Check every 100ms


  // Click Redirect to page



});
//   button.addEventListener('click', function(event) {
//     event.preventDefault();

//     const productId = this.getAttribute('data-product-id');
//     const variantId = this.getAttribute('data-variant-id');

//     console.log(`Product ID: ${productId}, Variant ID: ${variantId} added to wishlist.`);

//     // Disable the button to prevent multiple clicks
//     this.disabled = true;

//     // Your custom logic here (if needed)

//     // Reload the page after a short delay (e.g., 500ms)
//     setTimeout(() => {
//       window.location.reload();
//     }, 100);
//   });
// });

$(document).ready(function () {
  $('.wishlist-button').on('click', function () {
    var productId = $(this).data('product-id');

    // Your wishlist logic here, e.g., AJAX request to add product to wishlist
    console.log('Product ID:', productId);

    // Example of sending an AJAX request (customize this as per your wishlist app API)
    $.ajax({
      type: 'POST',
      url: '/wishlist/add',
      data: { product_id: productId },
      success: function (response) {
        alert('Product added to wishlist!');
      },
      error: function (xhr, status, error) {
        console.error('Error:', error);
        console.error('Status:', status);
        console.error('Response:', xhr.responseText);
        alert('There was an error adding the product to the wishlist.');
      }
    });
  });
});


// Quantity & cart button

// const QuantityElement = document.querySelector('.product-form__input.product-form__quantity');
// const BuyButtonElement = document.querySelector('.form-buy__inner');

// const TwoInnerWrap = document.createElement('div');

// TwoInnerWrap.classList.add('button-wrapper'); // Add a class

// QuantityElement.parentNode.insertBefore(TwoInnerWrap, QuantityElement);

// TwoInnerWrap.appendChild(QuantityElement);
// TwoInnerWrap.appendChild(BuyButtonElement);




const checkbox = document.getElementById("dark-mode");

if (checkbox) checkbox.addEventListener("change", () => {


  console.log("Checkbox changed. Dark mode toggled.");

  // Find the parent element with class product__info-wrapper
  const parentElement = document.querySelector(".product__info-wrapper");

  if (parentElement) {
    console.log("Found parent element:", parentElement);

    // Find all elements with an orig-value attribute that contains "Sleeve Logo"
    const targetElements = parentElement.querySelectorAll('.swatch-view-item[orig-value*="Sleeve Logo"], .swatch-view-item[orig-value*="Sleeve Design"]');


    if (targetElements.length > 0) {
      console.log(`Found ${targetElements.length} target elements with Sleeve Logo.`);

      targetElements.forEach(targetElement => {
        // Toggle the active class on the target element (parent element)

        document.body.classList.toggle("sleev-var");
        targetElement.classList.toggle("active");
        console.log("Toggled 'active' class on the target element:", targetElement);
      });
    } else {
      console.log("No target elements found with Sleeve Logo.");
    }
  } else {
    console.log("No parent element found.");
  }
});



function checkSleeveAvailability() {
  const productInfoWrapper = document.querySelector('.product__info-wrapper');

  if (productInfoWrapper) {
    const CheckSleev = productInfoWrapper.querySelectorAll('.swatch-view-item[orig-value*="Sleeve Logo"], .swatch-view-item[orig-value*="Sleeve Design"]');

    if (CheckSleev.length > 0) {
      console.log('Sleeve available');
      document.body.classList.remove("sleeve-not_available");
    } else {
      console.log('Sleeve not available');
      document.body.classList.add("sleeve-not_available");
    }
  } else {
    console.log('Parent container not found');
  }
}

// Observe the product__info-wrapper for any changes
const productInfoWrapper = document.querySelector('.product__info-wrapper');

if (productInfoWrapper) {
  const observer = new MutationObserver(function (mutationsList, observer) {
    checkSleeveAvailability();
  });

  // Observe the child elements of the wrapper for changes
  observer.observe(productInfoWrapper, { childList: true, subtree: true });
}

// Run once when the DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  checkSleeveAvailability();
});




function moveElement2() {
  var switchwrap = $('.switch-button-wrap');
  var variantDiv = $('.product__info-wrapper div[option-name=Color] .swatch-single');

  // Check for screen width (example: max 767px)
  if (window.innerWidth <= 767) {
    if (switchwrap.length && variantDiv.length) {
      variantDiv.append(switchwrap);
      clearInterval(moveInterval); // Stop the interval once the move is successful
    } else {
      console.log('Switchwrap or variant div not found.');
    }
  }
}

// Immediately try to move the element
moveElement2();

// Set the interval and store the interval ID
var moveInterval = setInterval(moveElement2, 1000);

$(document).ready(function () {

  $('body.product .treding-slider').css('visibility', 'visible').hide().fadeIn(500); // Adjust 1000 to your preferred duration
});


// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function () {
//     var element = document.querySelector('.cbb-frequently-bought-container');
//     if (element) {
//       element.style.display = 'block'; // or perform any action you want
//     }
//   }, 3000); // 3000 milliseconds = 3 seconds
// });











